import { render, staticRenderFns } from "./ButtonRedemptionStatus.vue?vue&type=template&id=bf7c679c&scoped=true&"
import script from "./ButtonRedemptionStatus.vue?vue&type=script&lang=js&"
export * from "./ButtonRedemptionStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7c679c",
  null
  
)

export default component.exports